import { ChartBase } from 'components/common';
import { ExportIcon } from 'components/icons';
import { CardBackground, Skeleton } from 'components/ui';

export default function LoadingStateChart({ chartTitle = 'Loading' }) {
  const loadingCards = (
    <div className="space-y-1">
      <Skeleton isLoaded={false}>
        <p className="leading-9 text-segments-32px">loading</p>
      </Skeleton>
      <Skeleton isLoaded={false}>
        <p className="text-base text-black text-opacity-50">loading</p>
      </Skeleton>
    </div>
  );

  return (
    <div className="mt-14">
      <div className="flex items-end justify-between px-2">
        <p className="text-lg leading-7 whitespace-nowrap">{chartTitle}</p>
        <Skeleton isLoaded={false}>
          <div className="flex items-center px-5 py-2.5 space-x-2 rounded-lg bg-segments-gray focus:outline-none">
            <p>Export</p>
            <ExportIcon className="w-5 h-5" />
          </div>
        </Skeleton>
      </div>
      <div className="mt-4">
        <CardBackground>
          <div className="p-10">
            <div className="flex justify-between">
              {[1, 2, 3, 4].map((item) => (
                <div key={item}>{loadingCards}</div>
              ))}
            </div>
            <div className="mt-8">
              <Skeleton isLoaded={false}>
                <p className="text-base text-black text-opacity-50">
                  Lorem ipsum dolor, sit amet consectetur adipisicing elit.
                  Voluptates blanditiis officia odit veritatis iste, omnis
                  consequatur error. Corrupti, ex corporis.
                </p>
              </Skeleton>
            </div>
            <hr className="my-8" />
            <Skeleton isLoaded={false}>
              <ChartBase type="bar" data={{}} options={{}} />
            </Skeleton>
          </div>
        </CardBackground>
      </div>
    </div>
  );
}
